import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckIcon } from "@/components/Icons";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
    const [sp] = useSearchParams();
    const nav = useNavigate();
    const [status, setStatus] = useState("checking");
    const sessionId = sp.get("session_id");
    const attempts = useRef(0);

    useEffect(() => {
        if (!sessionId) return;
        let cancelled = false;
        const poll = async () => {
            if (cancelled) return;
            attempts.current += 1;
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                if (data.payment_status === "paid") { setStatus("paid"); return; }
                if (data.status === "expired" || data.status === "failed") { setStatus("failed"); return; }
                if (attempts.current >= 20) { setStatus("timeout"); return; }
                setTimeout(poll, 2000);
            } catch {
                setStatus("failed");
            }
        };
        poll();
        return () => { cancelled = true; };
    }, [sessionId]);

    return (
        <div className="mx-auto max-w-lg px-6 py-24 text-center">
            {status === "checking" && (
                <>
                    <div className="animate-pulse h-16 w-16 rounded-sm bg-primary/10 mx-auto grid place-items-center">
                        <div className="h-2 w-2 rounded-full bg-primary animate-ping" />
                    </div>
                    <h1 className="font-heading text-3xl font-bold mt-6">Confirming payment…</h1>
                    <p className="text-muted-foreground mt-2">Hang tight, this only takes a few seconds.</p>
                </>
            )}
            {status === "paid" && (
                <>
                    <div className="h-16 w-16 bg-emerald-50 border border-emerald-200 mx-auto grid place-items-center">
                        <CheckIcon className="h-8 w-8 text-emerald-700" />
                    </div>
                    <h1 className="font-heading text-3xl font-bold mt-6">Booking confirmed</h1>
                    <p className="text-muted-foreground mt-2">Your seat is locked. Download your admit card from My Bookings.</p>
                    <Button className="mt-6 rounded-sm bg-primary hover:bg-primary/90" onClick={() => nav("/my-bookings")} data-testid="go-mybookings">Go to My Bookings</Button>
                </>
            )}
            {(status === "failed" || status === "timeout") && (
                <>
                    <h1 className="font-heading text-3xl font-bold mt-6">Payment {status === "failed" ? "failed" : "still pending"}</h1>
                    <p className="text-muted-foreground mt-2">If money was debited, it will be refunded within 5–7 business days.</p>
                    <Button className="mt-6 rounded-sm" variant="outline" onClick={() => nav("/my-bookings")}>Go to My Bookings</Button>
                </>
            )}
        </div>
    );
}
